import { Car16, Walk16 } from '@cian/ui-kit';
import * as React from 'react';

import { ETransportType } from '../../../../store/similar';

interface IIconsTransport {
  type: ETransportType;
}

export const IconsTransport: React.FC<IIconsTransport> = ({ type }) => {
  switch (type) {
    case ETransportType.Walk:
      return <Walk16 />;
    case ETransportType.Transport:
      return <Car16 />;
    default:
      return null;
  }
};

IconsTransport.displayName = 'IconsTransport';
